var React = require('react');

function Plus12x12 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Color=Black, State=Default, Size=12x12"},React.createElement("path",{"id":"Vector","d":"M6 1v5m0 0v5m0-5h5M6 6H1","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round"})));
}

Plus12x12.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = Plus12x12;

Plus12x12.default = Plus12x12;
